import {
  GetterMethods as StakingViewMethods,
  GetLockAmount as stakingGetLockAmount,
  GetStakeData as stakingGetStakeData,
} from './getters';
import {
  WeightedGetterMethods as StakingWeightedViewMethods,
  GetWeightedLockAmount as stakingGetWeightedLockAmount,
  GetWeightedStakeData as stakingGetWeightedStakeData,
} from './weighted';
import {
  UserMethods as StakingUserMethods,
  Lock as stakingLock,
  Unlock as stakingUnlock,
  LockETH as stakingLockETH,
  UnlockETH as stakingUnlockETH,
} from './user';

const NamedViewMethods = {
  stakingGetLockAmount,
  stakingGetStakeData,
};
const NamedUserMethods = {
  stakingLockETH,
  stakingUnlockETH,
  stakingLock,
  stakingUnlock,

};
const NamedWeightedViewMethods = {
  stakingGetWeightedLockAmount,
  stakingGetWeightedStakeData,
};

export const LockMethods = {
  ...NamedUserMethods,
  ...NamedViewMethods,
  ...NamedWeightedViewMethods,
};

export {
  StakingUserMethods,
  StakingViewMethods,
  StakingWeightedViewMethods,
};
export default LockMethods;